export const showDropDown =
  "absolute top-10 md:top-14 right-5 z-50 my-4 text-base list-none rounded divide-y  shadow bg-gray-700 divide-gray-600";

export const hideDropDown =
  "hidden my-4 text-base list-none rounded divide-y  shadow bg-gray-700 divide-gray-600";

export const showNav =
  "justify-between items-center w-full md:flex md:w-auto md:order-1";
export const hideNav =
  "hidden justify-between items-center w-full md:flex md:w-auto md:order-1";

export const od =
  "flex mr-3 text-sm bg-gray-800 rounded-full md:mr-0 focus:ring-4 focus:ring-gray-600";

export const cd = "flex mr-3 text-sm bg-gray-800 rounded-full md:mr-0";

export const on =
  "inline-flex items-center p-2 ml-1 text-sm rounded-lg md:hidden  text-gray-400 hover:bg-gray-700 focus:ring-gray-600";

export const cn =
  "inline-flex items-center p-2 ml-1 text-sm rounded-lg md:hidden  text-gray-400 hover:bg-gray-700";

export const showEaster =
  "overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 w-full md:inset-0 h-modal md:h-full";

export const hideEaster =
  "hidden overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 w-full md:inset-0 h-modal md:h-full";

export const wrong = "text-amber-800 font-bold px-3 py-1";
export const correct = "text-green-400 font-bold px-3 py-1";
export const neutral = "font-bold px-3 py-1";
